import {
  Autocomplete,
  Box,
  // Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import React, { useEffect, useState } from "react";
import ApiService from "../../services/ApiService";
import boxStyles from "../../styles/boxStyles";

const CreatePermissions = ({
  inputFields,
  setInputFields,
  readOnly = false,
  action,
  permissions,
  setPermissions,
}) => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  const handleChange = (index, idx, el) => {
    permissions.map((elements, indexx) => {
      if (indexx == index) {
        elements.map((el, idxx) => {
          if (idxx == idx) {
            permissions[index][idx]["checked"] = !el.checked;
            return false;
          }
        });
      }
    });

    setPermissions(permissions);
  };

  const handleKeyDown = async (e) => {
    setLoading(true);
    if (e.key == "Enter" || e.key == " ") {
      await getUsers(e.target.value);
    }
    setLoading(false);
  };

  const getUsers = async (val) => {
    if (action !== "create") return;
    setLoading(true);
    try {
      await ApiService.getListUserAdmin(val).then((res) => {
        if (res.data.isOk) {
          setUsers(res.data.payload);
        } else {
          alert(res.data.message);
          setTimeout(() => {
            // router("/");
          }, 500);
        }
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      alert("The Error was occured", error);
      setTimeout(() => {
        // router("/");
      }, 500);
    }
  };

  const handleChosePegawai = (e, val) => {
    if (!val == null || val != undefined) {
      setInputFields({
        userId: val.userId,
        jabatan: val.jabatan,
        email: val.email,
        namaPegawai: val.namalengkap,
        noPegawai: val.employeeId,
        nopek: val.nopek,
        roleId: "",
        activeStatus: "",
      });
    } else {
      setInputFields({
        userId: "",
        jabatan: "",
        email: "",
        namaPegawai: "",
        noPegawai: "",
        roleId: "",
        activeStatus: "",
      });
    }
  };

  const getPermissions = async () => {
    try {
      setLoading(true);
      await setPermissions([]);
      await ApiService.getListPermissions().then((res) => {
        if (res.data.isOk) {
          let result = res.data.payload;
          if (result.length > 0) {
            let resultPermissions = new Array();
            let tempData = new Array();
            let j = 1;
            let k = 0;
            for (let i in result) {
              result[i]["checked"] = false;
              if (action != "create" && inputFields.permission.length > 0) {
                if (inputFields.permission.search(result[i]["name"]) >= 0) {
                  result[i]["checked"] = true;
                }
              }
              tempData[j] = result[i];
              if (j == 5) {
                resultPermissions[k] = tempData;
                j = 0;
                tempData = [];
                k++;
              } else if (i == result.length - 1) {
                resultPermissions[++k] = tempData;
              }
              j++;
            }
            setPermissions(resultPermissions);
          }
        } else {
          alert(res.data.message);
          // router("/");
        }
        setLoading(false);
      });
    } catch (error) {
      alert("Error was occured " + error);
      // router("/");
    }
  };

  useEffect(() => {
    if (action == "create") {
      setInputFields({
        emailUser: "",
        permissionIds: [],
      });
    }
    getPermissions();
  }, []);

  return (
    <>
      <Box component="div" sx={boxStyles}>
        <Grid container spacing={3}>
          {action == "create" ? (
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Stack spacing={2}>
                {action == "create" ? (
                  <FormControl fullWidth>
                    <Autocomplete
                      loading={loading}
                      name="idNamaPegawai"
                      onChange={(e, value) => handleChosePegawai(e, value)}
                      onKeyDown={handleKeyDown}
                      required
                      defaultValue={users.find(
                        (item) => item.id === inputFields.noPegawai
                      )}
                      getOptionLabel={(option) => option.namalengkap}
                      options={users}
                      renderInput={(params) => (
                        <TextField {...params} label="Nama Pegawai" />
                      )}
                      getOptionSelected={(option, value) =>
                        option.namalengkap === value.namalengkap
                      }
                    />
                  </FormControl>
                ) : (
                  ""
                )}
              </Stack>
            </Grid>
          ) : (
            ""
          )}
          <Grid item xl={12} lg={12} sm={12} xs={12}>
            <Stack spacing={2}>
              {action == "create" ? (
                <TextField
                  name="noPegawai"
                  label="No. Pegawai"
                  variant="standard"
                  fullWidth
                  value={inputFields.noPegawai ? inputFields.noPegawai : ""}
                  InputLabelProps={{ shrink: inputFields.noPegawai !== "" }}
                  onChange={(e) =>
                    setInputFields({
                      ...inputFields,
                      noPegawai: e.target.value,
                    })
                  }
                  disabled={readOnly}
                />
              ) : (
                ""
              )}
              {action == "create" ? (
                <TextField
                  name="jabatan"
                  label="Jabatan"
                  variant="standard"
                  fullWidth
                  value={inputFields.jabatan ? inputFields.jabatan : ""}
                  InputLabelProps={{ shrink: inputFields.jabatan !== "" }}
                  onChange={(e) =>
                    setInputFields({
                      ...inputFields,
                      jabatan: e.target.value,
                    })
                  }
                  disabled={readOnly}
                />
              ) : (
                ""
              )}
              <TextField
                name="email"
                label="Email Pegawai"
                variant="standard"
                fullWidth
                value={inputFields.email ? inputFields.email : ""}
                InputLabelProps={{ shrink: inputFields.email !== "" }}
                onChange={(e) =>
                  setInputFields({
                    ...inputFields,
                    email: e.target.value,
                  })
                }
                disabled={readOnly || action == "read" || action == "edit"}
              />
              <FormLabel component="legend">Search Permission Name</FormLabel>
              <Box sx={{ display: "flex" }} style={{ overflowX: "scroll" }}>
                {permissions.map((elements, index) => (
                  <FormGroup aria-label="position" key={index + "formgroup"}>
                    {elements.map((el, idx) => {
                      return (
                        <FormControlLabel
                          key={index * index + idx * idx}
                          control={
                            <Checkbox
                              defaultChecked={
                                permissions[index][idx]["checked"]
                              }
                              onChange={() => handleChange(index, idx, el)}
                              // inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                          label={el.name}
                        />
                      );
                    })}
                  </FormGroup>
                ))}
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CreatePermissions;
